// extracted by mini-css-extract-plugin
export default {"container":"EditStageModal_container__2xgBI","title":"EditStageModal_title__3a-Tt","fullWidth":"EditStageModal_fullWidth__PYX+e"};